import * as React from 'react';
import {
  ExperimentsProvider,
  useExperiments,
} from '@wix/wix-experiments-react';
import { TranslationProvider } from '../../hooks/use-translation';
import { ManageInstalledAppsPage } from '../manage-installed-apps-page';
import { ModalProvider } from '../../hooks/use-modal/use-modal';

export { Origin } from '../manage-installed-apps-page';

export function ManageInstalledApps(
  props: React.ComponentProps<typeof ManageInstalledAppsPage>,
) {
  const { experiments } = useExperiments();

  return (
    <ExperimentsProvider options={{ scope: 'app-market-editor' }}>
      <TranslationProvider
        locale={props.locale}
        baseUrl={props.manageAppsStaticsUrl}
        experiments={experiments}
      >
        <ModalProvider>
          <ManageInstalledAppsPage {...props} />
        </ModalProvider>
      </TranslationProvider>
    </ExperimentsProvider>
  );
}
